import { HttpStatusCode } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AlertService } from "@commonServices/alert.service";
import { AlertDisplayType } from "@commonEnums/AlertDisplayType";
import { TranslateService } from "@ngx-translate/core";

@Injectable({
	providedIn: "root"
})
export class RequestService {
	// Verhindert, dass z.B. ein laufendes Polling bei dauerhaft fehlender Berechtigung
	// alle paar Sekunden einen neuen Toast erzeugt.
	private static readonly permissionToastDebounceMs = 5000;
	private lastPermissionToastAt = 0;

	constructor(
		private readonly alertService: AlertService<string>,
		private readonly translateService: TranslateService
	) { }

	public errorHandling(
		e: any,
		defaultErrorReturn: any,
		specificCodes?: { status: HttpStatusCode; return: any }[]
	) {
		if (specificCodes && specificCodes.some(s => s.status === e.status)) {
			const returnValue = specificCodes.find(f => f.status === e.status)?.return
			return returnValue instanceof Function ? returnValue() : returnValue
		} else {
			if (e?.status === HttpStatusCode.Unauthorized || e?.status === HttpStatusCode.Forbidden) {
				const now = Date.now();
				if (now - this.lastPermissionToastAt > RequestService.permissionToastDebounceMs) {
					this.lastPermissionToastAt = now;
					this.alertService.sendMessage('global', AlertDisplayType.Danger, this.translateService.instant('global.action-permission-denied'));
				}
			}
			return defaultErrorReturn;
		}
	}
}
